'use strict';

const h = require('phy');

const VariablePricingRepeat = props => {
  const {
    pricingMetadata: { offerLabelDescriptive },
    regularPrice: { formattedAmount },
  } = props;

  return h(
    '.variable-pricing-repeat',
    h('span.variable-pricing-repeat-text', offerLabelDescriptive),
    h('span.variable-pricing-repeat-price', formattedAmount)
  );
};

module.exports = VariablePricingRepeat;
